module.exports = __webpack_public_path__ + "media/src/images/icons/article_icon_small-e2be1d894afc50af5c3a44db835b53ec.svg";